import React, { useEffect, useState, useCallback, useContext } from 'react';
import { LoginContext } from "../AuthContext/LoginContext";
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons-dt/js/buttons.dataTables.js';
import 'jszip/dist/jszip.min.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const UsersListLayer = () => {
    const [users, setUsers] = useState([]);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const navigate = useNavigate();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const { hasPermission } = useContext(LoginContext);

    const fetchUsers = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`${API_BASE_URL}/backend/users/get-all-users`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.data.status) {
                setUsers(response.data.data);
            } else {
                toast.error("Failed to fetch users.");
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error("Error fetching users.");
        } finally {
            setLoading(false);
        }
    }, [API_BASE_URL]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    useEffect(() => {
        let table;
        if (users.length > 0 && !$.fn.DataTable.isDataTable('#dataTable')) {
            table = $('#dataTable').DataTable({
                dom: 'Bfrtip',
                buttons: [
                    {
                        extend: 'csv',
                        text: '<i class="iconify" data-icon="mdi:file-delimited-outline"></i> CSV',
                        className: 'btn btn-primary btn-sm',
                        exportOptions: {
                            columns: ':visible'
                        }
                    },
                    'colvis'
                ],
                pageLength: 10,
                responsive: true,
                destroy: true,
            });
        }

        return () => {
            if (table) {
                table.destroy();
            }
        };
    }, [users]);

    const exportToCSV = () => {
        $('#dataTable').DataTable().button('.buttons-csv').trigger();
    };

    const exportToPDF = (tableSelector = '#dataTable', fileNamePrefix = 'CMS_Export') => {
        try {
            const table = $(tableSelector).DataTable();
            if (!table) throw new Error("Table not found or not initialized.");
    
            const skipColumnTitles = ['Action'];
            const headers = [];
            const includedIndexes = [];
    
            // 1. Get visible and valid headers
            table.columns().every(function(index) {
                if (this.visible()) {
                    const column = this;
                    const headerEl = column.header();
                    const headerText = headerEl?.textContent?.trim() || `Column ${index + 1}`;
    
                    if (!skipColumnTitles.includes(headerText)) {
                        headers.push({ title: headerText, index });
                        includedIndexes.push(index);
                    }
                }
                return true;
            });
    
            // 2. Get filtered and sorted data
            const pdfData = [];
            table.rows({ filter: 'applied' }).every(function () {
                const rowEl = this.node(); // Get the actual DOM node for the row
                const cells = rowEl.children;
                const rowValues = [];
    
                includedIndexes.forEach(i => {
                    const cell = cells[i];
                    if (!cell) {
                        rowValues.push('');
                        return;
                    }
    
                    // Get clean visible text without HTML
                    const text = cell.innerText?.trim() || '';
                    rowValues.push(text);
                });
    
                pdfData.push(rowValues);
                return true;
            });
    
            // 3. Create PDF
            const doc = new jsPDF({
                orientation: pdfData.length > 0 && pdfData[0].length > 5 ? 'landscape' : 'portrait',
                unit: 'mm'
            });
    
            const now = new Date();
            const timestamp = now.toISOString()
                .replace(/T/, '_')
                .replace(/\..+/, '')
                .replace(/:/g, '-');
            const fileName = `${fileNamePrefix}_${timestamp}`;
    
            // 4. Title and meta
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(16);
            doc.text(`${fileNamePrefix} Report`, 14, 10);
    
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            doc.text(`Generated: ${now.toLocaleString()}`, 14, 15);
            doc.text(`Total Records: ${pdfData.length}`, 14, 20);
    
            // 5. Table
            autoTable(doc, {
                startY: 25,
                head: [headers.map(h => h.title)],
                body: pdfData,
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    overflow: 'linebreak',
                    halign: 'left'
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: 255,
                    fontStyle: 'bold',
                    halign: 'center'
                },
                margin: {
                    top: 25,
                    left: 10,
                    right: 10
                }
            });
    
            // 6. Page numbers
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(8);
                doc.text(
                    `Page ${i} of ${pageCount}`,
                    doc.internal.pageSize.width - 20,
                    doc.internal.pageSize.height - 10
                );
            }
    
            doc.save(`${fileName}.pdf`);
        } catch (error) {
            console.error("PDF Export Error:", error);
            toast.error("Failed to generate PDF. Please try again.");
        }
    };
    
    
    
    const handleShowDetailsModal = (user) => {
        setSelectedUser(user);
        setShowDetailsModal(true);
    };

    const handleEditUser = (userId) => {
        navigate(`/users/update/${userId}`);
    };

    const handleShowDeleteModal = (rescuer) => {
        setSelectedUser(rescuer);
        setShowDeleteModal(true);
    };

    const handleDeleteUser = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.patch(
                `${API_BASE_URL}/backend/users/delete/${selectedUser._id}`,
                {}, 
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status) {
                toast.success("User deleted successfully.");
                fetchUsers();
            } else {
                toast.error("Failed to delete user.");
            }
        } catch (error) {
            console.error("Error deleting user:", error);
            toast.error("Error deleting user.");
        } finally {
            setShowDeleteModal(false);
        }
    };

    return (
        <div className="card basic-data-table">
            <ToastContainer />
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">Users Data</h5>
                <div className="export-buttons d-flex align-items-center">
                    <button onClick={exportToCSV} className="btn btn-success btn-sm me-2 d-flex align-items-center">
                        <Icon icon="mdi:file-delimited-outline" className="me-1" style={{ fontSize: '16px' }} /> 
                        CSV
                    </button>
                    <button onClick={() => exportToPDF('#dataTable', 'User_Export')} className="btn btn-danger btn-sm me-2 d-flex align-items-center">
                        <Icon icon="mdi:file-pdf-box" className="me-1" style={{ fontSize: '16px' }} /> 
                        PDF
                    </button>
                </div>
            </div>
            
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table bordered-table mb-0" id="dataTable" data-page-length={10}>
                        <thead>
                            <tr>
                                <th scope="col">S.L</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Phone Number</th>
                                <th scope="col">Department</th>
                                <th scope="col">Designation</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                               Array.from({ length: 10 }).map((_, index) => (
                                    <tr key={index}>
                                        <td><Skeleton width={30} /></td>
                                        <td><Skeleton width={120} /></td>
                                        <td><Skeleton width={150} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={30} /></td>
                                    </tr>
                                ))
                            ) : users && users.length > 0 ? (
                                users.map((user, index) => (
                                    <tr key={user._id}>
                                        <td>{index + 1}</td>
                                        <td>{`${user.first_name} ${user.last_name}`}</td>
                                        <td>{user.email}</td>
                                        <td>{user.phone_no}</td>
                                        <td>{user.department}</td>
                                        <td>{user.designation}</td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                            {hasPermission('users', 'view') && (
                                                <button
                                                    type="button" onClick={() => handleShowDetailsModal(user)}
                                                    className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon
                                                        icon="majesticons:eye-line"
                                                        className="icon text-xl"
                                                    />
                                                </button>
                                            )}
                                            {hasPermission('users', 'edit') && (
                                                <button
                                                onClick={() => handleEditUser(user._id)}
                                                type="button" 
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </button>
                                            )}
                                            {hasPermission('users', 'delete') && (
                                                <button
                                                    type="button"
                                                    onClick={() => handleShowDeleteModal(user)}
                                                    className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon
                                                        icon="fluent:delete-24-regular"
                                                        className="menu-icon"
                                                    />
                                                </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center">No users found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>User Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedUser && (
                        <div>
                            <p><strong>Name:</strong> {`${selectedUser.first_name} ${selectedUser.last_name}`}</p>
                            <p><strong>Email:</strong> {selectedUser.email}</p>
                            <p><strong>Phone Number:</strong> {selectedUser.phone_no}</p>
                            <p><strong>Department:</strong> {selectedUser.department}</p>
                            <p><strong>Designation:</strong> {selectedUser.designation}</p>
                            <p><strong>Status:</strong> {selectedUser.isDeleted ? 'Inactive' : 'Active'}</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete {selectedUser?.first_name + ' ' + selectedUser?.last_name || 'this user'}?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteUser}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default UsersListLayer;